import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-print-magic-box',
    templateUrl: './print-magic-box.component.html',
    styleUrls: ['./print-magic-box.component.scss']
})
export class PrintMagicBoxComponent implements OnInit {
    @Input() exercise_text: string;
    @Input() page_size: string;
    @Input() answer_table: boolean = false;
    @Input() exercise_hint: string;
    exercise_body: any;

    constructor() {}

    public ngOnInit(): void {
        this.exercise_body = JSON.parse(this.exercise_text);
    }

    public computeHeight(): string {
        let table_height: string = null;
        switch (this.page_size) {
            case 'A7':
                table_height = '160px';
                break;
            case 'A3':
                table_height = '180px';
                break;
            default:
                table_height = '240px';
        }
        return table_height;
    }
}
